import { normalizeSchoolInfo, readJsonStorage } from '@/utils/schoolContext'

function readInitialSchool() {
  const schoolInfo = normalizeSchoolInfo(readJsonStorage('schoolInfo', {}))
  if (schoolInfo.schoolId || schoolInfo.schoolName) return schoolInfo
  const userInfo = readJsonStorage('userInfo', {})
  return normalizeSchoolInfo({
    schoolId: localStorage.getItem('schoolId') || userInfo.schoolId || '',
    schoolName: userInfo.schoolName || userInfo.school || ''
  })
}

export default {
  state: {
    currentSchool: readInitialSchool()
  },
  getters: {
    currentSchoolInfo(state) {
      return normalizeSchoolInfo(state.currentSchool)
    },
    currentSchoolId(state, getters) {
      return getters.currentSchoolInfo.schoolId || ''
    }
  },
  mutations: {
    setCurrentSchoolInfo(state, school) {
      state.currentSchool = normalizeSchoolInfo(school)
    },
    clearCurrentSchoolInfo(state) {
      state.currentSchool = normalizeSchoolInfo({})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/school.js